import { render, staticRenderFns } from "./addKnowledgeFolder.vue?vue&type=template&id=2c28def9&scoped=true&lang=pug"
import script from "./addKnowledgeFolder.vue?vue&type=script&lang=js"
export * from "./addKnowledgeFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c28def9",
  null
  
)

export default component.exports